import React, {useState} from "react";
import {ActionButton, Alert} from "./components/FormComps";
import {capFirst} from "./components/StringUtils";
import {ModalDialog} from "./components/DialogUtils";
import {useIntlEx} from "./components/IntlUtils";
import {useSolv} from "./components/SolvProvider";
import {BroadcastView} from "./components/BroadcastComps";
import {PurchaseCreditsControls} from "./components/CreditTransactionUtils";
import {mkHref} from "./components/AccountUtils";
import getLogger from "./components/Logging.js"
import "./App.css"

const log = getLogger("BroadcastPublishDialog")

export function BroadcastPublishDialog(props) {

  const {api, env, session, setBusy} = useSolv()
  const {intl} = useIntlEx()

  const [alert, setAlert] = useState(null)
  const [touched, setTouched] = useState(null)

  const [publishDialogState, setPublishDialogState] = useState(null)
  const [tenantCredits, setTenantCredits] = useState(null)
  const [topupCredits, setTopupCredits] = useState(null)

  async function handlePublish() {
    // log.debug("handlePublishWClick: invoked", props.tenant)

    setBusy(intl.msg("publishing"))

    try {

      const payload = {
        provider: "SOLV_CREDITS",
        broadcastId: props.broadcast?.broadcastId,
        details: {}
      }

      // log.debug("handlePublishWithCredits: payload=", payload)

      const res = await api.submitBroadcast(props.tenant.tenantId, payload)

      // log.debug("handlePublishWithCredits: publishhMutation: res=", res)

      setAlert(null)
      setPublishDialogState("THANK_YOU")
      setTouched(false)

      // window.location = mkHref({suffix: "/broadcasts", user: user, tenant: props.tenant})

    }
    catch (ex) {
      log.debug("publishedWithCredits failed", JSON.stringify(ex))
      switch (ex.code) {
        case "INSUFFICIENT_FUNDS":
          const tenantCredits = parseFloat(ex.details.tenantCredits || 0.0)
          const topupCredits = parseFloat(ex.details.credits)
          if ("FUNDED" !== props.tenant.tenantPlanId) {
            setPublishDialogState("PAY")
            setTenantCredits(tenantCredits)
            setTopupCredits(topupCredits)
          }
          else {
            setAlert({type: "error", text: intl.msg("broadcast_publish_error_insufficient_funds", {tenantCredits: tenantCredits, topupCredits: topupCredits})})
          }
          break
        default:
          setAlert({type: "error", text: intl.msg("error_failed")})
      }
    }
    finally {
      // log.debug("Done publishing...")
      setBusy(null)
    }
  }

  function handleFailure(alert) {
    setAlert(alert)
  }

  function handleOpenDialog() {
    setAlert(null)
    setPublishDialogState("START")
    setAlert(null)
  }

  function handleCloseDialog() {
    window.location = mkHref({suffix: `/broadcasts/${props.broadcast.broadcastId}`, tenant: props.tenant, user: session?.user})
  }

  return (
    props.tenant &&
      <>
        <ModalDialog
          dialogId="dlg_publish"
          size="md"
          keyboard="true"
          backdrop="static"
          onOpen={handleOpenDialog}
          onClose={handleCloseDialog}>

          <ModalDialog.Header
            title={intl.msg("broadcast_publish_title")}
            alert={alert}/>

          <ModalDialog.Body>
            <section className="main pb-0">
            {
              "START" === publishDialogState ? (
                "TRIAL" === props.tenant.tenantPlanId ? (
                  <>
                    <div>
                      <Alert alert={{error: intl.msg("upgrade_plan_text_1", {tenantPlan: capFirst(props.tenant.tenantPlanId)})}}/>
                    </div>
                    <center className="mt-3">
                      {intl.msg("upgrade_plan_text_2")}
                    </center>
                    <section className="paypal" style={{display: "flex", justifyContent: "end", alignItems: "center", padding: "20px 1px", margin: "0 -2px", borderTop: "1px solid var(--form-divider-color)"}}>
                      <div style={{display: "flex", justifyContent: "end"}}>
                        <button type="button" className="btn btn-secondary" data-dismiss="modal" aria-label="Close" onClick={handleCloseDialog}>
                          {intl.msg("cancel")}
                        </button>
                      </div>
                    </section>
                  </>
                ) : (
                  <>
                    <div className="mb-3">
                      <label>{intl.msg("broadcast_publish_text_1")}</label>
                    </div>
                    <BroadcastView tenant={props.tenant} broadcast={props.broadcast} reachEstimates={props.reachEstimates}/>
                  </>
                )
              ) : "PAY" === publishDialogState ? (
                <>
                  <div style={{marginBottom: "20px"}}>
                    {
                      !alert &&
                        <center>
                          <Alert alert={{type: "warning", title: intl.msg("broadcast_publish_insufficient_credits_title"), text: intl.msg("broadcast_publish_insufficient_credits_text", {tenantCredits: `${intl.numFormat.format(tenantCredits)} Credits`, targetBudget: `${intl.numFormat.format(props.broadcast?.targetBudget)} Credits`, topupCredits: `${intl.numFormat.format(props.broadcast?.targetBudget - tenantCredits)} Credits`, a: chunks => <a className="text-link" href="/CreditTransactions.js">{chunks}</a>})}}/>
                        </center>
                    }
                    <div className="mt-3">

                      <PurchaseCreditsControls
                        tenant={props.tenant}
                        paymentInfo={{
                          minimumCredits: topupCredits, //props.broadcast?.targetBudget - tenantCredits,
                          currencyCode: props.tenant.currencyCode || "USD",
                          usdMultiplier: props.broadcast.usdMultiplier,
                          description: intl.msg("credit_transaction_description_purchase"),
                          details: {
                            broadcast: {
                              broadcastId: props.broadcast?.broadcastId,
                              broadcastName: props.broadcast?.broadcastName
                            }
                          }
                        }}
                        options={{
                          offlinePayment: false,
                        }}
                        onSuccess={handlePublish}
                        onFailure={handleFailure}
                      />

                    </div>
                  </div>

                </>

              ) : "THANK_YOU" === publishDialogState ? (
                <>
                  <section className="paypal">
                    <center style={{marginBottom: "10px"}}>
                      <Alert alert={{type: "success", text: intl.msg("broadcast_publish_thank_you_alert")}}/>
                    </center>
                    <label className="mt-3">{intl.msg("broadcast_publish_thank_you_text")}</label>
                    <center className="m-3">
                      <button type="button" className="btn btn-secondary" data-dismiss="modal" aria-label="Close" style={{marginLeft: "8px"}} onClick={handleCloseDialog}>
                        {intl.msg("ok")}
                      </button>
                    </center>
                  </section>
                </>
              ) : (
                <>
                  <section className="paypal">
                    <center>
                      <button type="button" className="btn btn-secondary" data-dismiss="modal" aria-label="Close" style={{marginLeft: "8px"}} onClick={handleCloseDialog}>
                        {intl.msg("ok")}
                      </button>
                    </center>
                  </section>
                </>
              )
            }
          </section>
          </ModalDialog.Body>

          {
            "START" === publishDialogState &&
              <ModalDialog.Footer>
                <small style={{color: "var(--form-control-label-muted-color)"}}>
                  {intl.msg("broadcast_publish_by_clicking")}
                </small>
                <ModalDialog.Footer.Controls>
                  <ActionButton name="cancel" onClick={handleCloseDialog}/>
                  <ActionButton name="publish" flavor="primary" onClick={handlePublish}/>
                </ModalDialog.Footer.Controls>
              </ModalDialog.Footer>
          }

        </ModalDialog>
      </>
  )

}
